

import barba from '@barba/core';
import ScrollTrigger from '@terwanerik/scrolltrigger'
import anime from 'animejs';


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.trigger = new ScrollTrigger()
            this.initailTrigger()
        });
        barba.hooks.leave((data) => {
            this.trigger.kill()
        });
        barba.hooks.after((data) => {
            this.trigger = new ScrollTrigger()
            this.initailTrigger()
        });

    }
    initailTrigger(){
        this.trigger.add('[data-trigger]', {
            once: true,
            offset: {
               
                viewport: {
                    x: 0,
                    y: (trigger, frame, direction) => {
                        return trigger.visible ? 0 : 0.3
                    }
                }
            },
            toggle: {
                // class: {
                //     in: 'visible',
                //     out: ['invisible', 'extraClassToToggleWhenHidden']
                // },
                // callback: {
                //     in: null,
                //     visible: null,
                //     out: (trigger) => {
                //         return new Promise((resolve, reject) => {
                //             setTimeout(resolve, 10)
                //         })
                //     }
                // }
            }
        })

        this.trigger.add('[data-linestroke-animation]', {
            once: true, // same functionality as the `once` flag in v0.x
            
            toggle: {
                 class: {
                    in: 'visible',
                    out: 'invisible'
                },
                callback: {
                    in: (trigger) => {
                        const timeline = anime.timeline()
                        timeline.add({
                            targets:trigger.element.querySelector(".card"),
                            opacity:[0,1],
                            scale: [1.1,1],
                            duration:800,
                            easing:"easeOutSine",
                            delay: 300
                        })
                        .add({
                            targets:trigger.element.querySelector(".card__shadow"),
                            opacity:[0,1],
                            scale: [1.1,1],
                            translateY: [100,0],
                            translateX: [100,0],
                            easing:"easeOutSine",
                            duration:800
                        },"-=800")

                        const offset = 50
                        const easing = 'easeInOutSine'
                        const duration = 1200

                        const pathline = anime.timeline()
                        trigger.element.querySelector(".p-index__credo--cursives").style.opacity = 1;

                        const paths =trigger.element.querySelectorAll(".p-index__credo--cursives .paths");

                        if(paths.length > 0){
                            paths.forEach( (path , i) => {
                                let o = (i === 0) ? offset:"-="+ offset
                            
                                pathline.add({
                                    targets : path,
                                    strokeDashoffset: [anime.setDashoffset, 0],
                                    easing: easing,
                                    duration : (duration / paths.length),
                                } ,o)
                            })
                        }
                    }
                }
            }
        })
        this.trigger.add('[data-motto-animation]', {
            once: true, // same functionality as the `once` flag in v0.x
            
            toggle: {
                 class: {
                    in: 'visible',
                    out: 'invisible'
                },
                callback: {
                    in: (trigger) => {
                        const targetSvg = trigger.element.querySelector(".p-index__motto--heading svg");
                        const timeline = anime.timeline()
                        .add({
                            targets:trigger.element.querySelector(".p-index__motto--heading"),
                            // update: function(anim){
                            //     let blur = 0;
                            //     if(anim.progress > 2){
                            //         blur = 100 - anim.progress
                            //     }
                            //     targetSvg.style.filter = 'blur(' + blur + 'px)'
                            // },
                            opacity:[0,1],
                            easing:"easeInOutQuart",
                            duration:1200
                        })
                        .add({
                            targets:trigger.element.querySelector(".p-index__motto--sub"),
                            opacity:[0,1],
                            translateY: [20,0],
                            easing:"easeOutExpo",
                            duration:1200
                        },"-=400")
                        .add({
                            targets:trigger.element.querySelector(".p-index__motto--content"),
                            opacity:[0,1],
                            translateY: [20,0],
                            easing:"easeOutExpo",
                            duration:1200
                        },"-=400")
                    }
                }
            }
        })
        
    }
}